(() => {
  const script = document.currentScript;
  const pixelId = script?.dataset.pixelId?.trim();
  if (!pixelId || !/^[A-Za-z0-9_-]{8,100}$/.test(pixelId) || script.dataset.designMode === 'true') return;

  let initialized = false;
  let allowed = false;
  let lastCheckout = 0;

  const loadPixel = () => {
    if (!window.oaiq) {
      const queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
      const sdk = document.createElement('script');
      sdk.async = true;
      sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      script.parentNode.insertBefore(sdk, script.nextSibling);
    }
    // An earlier visit may have stored a denied state. Explicitly apply the
    // current Shopify permission before initialization.
    window.oaiq('consent', true);
    window.oaiq('init', { pixelId });
    initialized = true;
  };

  const syncConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.marketingAllowed !== 'function') return;
    allowed = privacy.marketingAllowed() === true &&
      (typeof privacy.saleOfDataAllowed !== 'function' || privacy.saleOfDataAllowed() === true);
    if (allowed && !initialized) loadPixel();
    else if (initialized) window.oaiq('consent', allowed);
  };

  const measureCheckout = (form) => {
    if (!allowed || !initialized) return;
    const now = Date.now();
    if (now - lastCheckout < 1500) return; // Ignore duplicate submit attempts.
    lastCheckout = now;
    const id = `checkout_${now}_${Math.random().toString(36).slice(2, 10)}`;
    const data = { type: 'contents' };
    const amount = Number(form?.dataset.muyaCheckoutAmount);
    const currency = form?.dataset.muyaCheckoutCurrency;
    if (Number.isSafeInteger(amount) && amount >= 0 && /^[A-Z]{3}$/.test(currency || '')) {
      data.amount = amount;
      data.currency = currency;
    }
    window.oaiq('measure', 'checkout_started', data, { event_id: id });
  };

  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('submit', (event) => {
    if (event.submitter?.name === 'checkout' && !event.submitter.disabled) measureCheckout(event.target);
  }, true);

  if (window.Shopify?.customerPrivacy?.marketingAllowed) syncConsent();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) syncConsent();
    });
  }
})();
